<template>
  <div class="animated-process-indicator">
    <AnimatedGearIcon class="animated-process-indicator__icon" />
    <h4 class="animated-process-indicator__heading">{{ text }}</h4>
  </div>
</template>

<script>
import AnimatedGearIcon from './AnimatedGearIcon';

export default {
  name: 'AnimatedProcessIndicator',
  components: { AnimatedGearIcon },
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.animated-process-indicator {
  margin: $global-margin * 3 0;

  &__icon {
    height: rem-calc(150px);
    margin-bottom: $global-margin;
  }

  &__heading {
    text-align: center;
    font-size: 1.5rem;
  }
}
</style>
